import request from '../../src/state/modules/axios'

export function getSubjects(data){
    return request({
        url: '/api/subjects',
        method: 'get',
        params: data
    })
}

export function getSubjectNameById(data){
    return request({
        url: `/api/subjects/${data.id}`,
        method: 'get',
    })
}

export function addSubject(data){
    return request({
        url:'/api/subjects',
        method:'post',
        data
    })
}

export function editSubject(data){
    return request({
        url: `/api/subjects/${data.id}`,
        method:'put',
        data
    })
}

export function getSubjectById(data){
    return request({
        url: `/api/subjects/${data.id}`,
        method: 'get',
    })
}

export function subjectById(){
    return request({
        url : `/api/subjects`,
        method: 'get'
    })
}

export function deleteSubject(data){
    return request({
        url: `/api/subjects/${data.id}`,
        method: 'delete'
    })
}
